// Tema claro/escuro do Connect (aluno e professor). A escolha fica salva no
// usuario (como o idioma) e espelhada no navegador: o login grava com
// saveTheme(), o botao da barra lateral chama setTheme() e a API. As cores vem
// dos tokens --pc-* de src/styles/theme.css, que mudam com data-theme no <html>.
//
// So o ApplicationTemplate (Connect logado) liga o tema: ao sair dele (logout,
// site publico) o escuro e desligado, para nao vazar para paginas que nao
// foram desenhadas para ele.
export const THEMES = ["light", "dark"];
const STORAGE_KEY = "theme";

export function normalizeTheme(value) {
  return THEMES.includes(value) ? value : "light";
}

// Ha escolha gravada neste navegador? (sessoes de antes do tema no usuario)
export function hasStoredTheme() {
  try {
    return THEMES.includes(localStorage.getItem(STORAGE_KEY));
  } catch {
    return false;
  }
}

// Grava sem aplicar: o login guarda o tema do usuario e o ApplicationTemplate
// aplica ao montar o Connect.
export function saveTheme(theme) {
  try {
    localStorage.setItem(STORAGE_KEY, normalizeTheme(theme));
  } catch {
    // Sem armazenamento (aba anonima restrita): vale so nesta sessao.
  }
}

export function storedTheme() {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return THEMES.includes(value) ? value : "light";
  } catch {
    return "light";
  }
}

// Aplica sem gravar: usado ao abrir o Connect e ao sair dele.
export function applyTheme(theme, vuetify) {
  const dark = theme === "dark";
  const root = document.documentElement;

  if (dark) root.setAttribute("data-theme", "dark");
  else root.removeAttribute("data-theme");

  if (vuetify) vuetify.theme.dark = dark;
}

// Troca pelo botao: grava e anima a troca de cores por um instante (o
// theme.css so liga a transicao enquanto data-theme-switching existe, para
// nao deixar toda a interface com transicao de cor o tempo todo).
export function setTheme(theme, vuetify) {
  const next = normalizeTheme(theme);
  const root = document.documentElement;

  saveTheme(next);

  root.setAttribute("data-theme-switching", "");
  applyTheme(next, vuetify);
  window.setTimeout(() => root.removeAttribute("data-theme-switching"), 320);
}
